import { Injectable } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';

import { User } from '../../models';
import { TermsOfServiceDataService } from '../data-services/';

@Injectable({
    providedIn: 'root'
})
export class TermsOfServiceLogicService {

    private _termsOfServiceAccepted = new Subject<boolean>();
    termsOfServiceAccepted$ = this._termsOfServiceAccepted.asObservable();

    constructor(
        private _termsOfServiceDataService: TermsOfServiceDataService,
        private _snackbar: MatSnackBar
    ) {
    }

    acceptTermsOfService(userId: string, updatedUser: User): void {
        this._termsOfServiceDataService.acceptTermsOfService(userId, updatedUser)
            .subscribe({
                next: () => {
                    this._termsOfServiceAccepted.next(true);
                },
                error: () => {
                    this._termsOfServiceAccepted.next(false);
                    this._snackbar.open('An error has occurred accepting the Terms of Service. Please try again.', 'Close', { duration: 2000 });
                }
            });
    }
}
